import chartdata from "./API/ChartData";
import webdata from "./API/WebData";
import cindex from "./API/Cindex";
import statistic from "./API/Statistic";
import overview from "./API/Overview-Table";
import statsbox from "./API/CardStats";
import industry from "./API/Industry";
import site from "./API/Site";
import analytics from "./API/Analytics";
import banner from "./API/Banner";
import power_bi from "./API/Power-Bi";
import dataDev from "./API/DataDeveloper";
export default {
  statistic,
  chartdata,
  webdata,
  cindex,
  industry,
  overview,
  statsbox,
  site,
  analytics,
  banner,
  power_bi,
  dataDev,
};
